export const ReviewColor = {
  ink: "#172B33",
  muted: "#607178",
  line: "#E2E9E7",
  surface: "#FFFFFF",
  subtle: "#F5F7F6",
  accent: "#176B57",
  accentSoft: "#EAF3EF",
  warning: "#805B18",
  warningBg: "#FBF4E5",
  danger: "#A34040",
  dangerBg: "#FAEEEE",
} as const;
